import http from 'util/http'

/**
 * 后去反馈分类
 */
export function getFeedbackCategory() {
  return http.get('/newxyrj/public/user/feedback/category', {})
}
/**
 * 更新反馈状态
 * @param {number} id 反馈id
 * @param {string} status 要更新的状态
 */
export function updateFeedbackState(id: number, status: string) {
  return http.post('/newxyrj/public/user/feedback/update', {
    feedback_id: id,
    status,
  })
}

/**
 * 用户反馈
 * @param {number} id 反馈分类id
 * @param {string} content 反馈内容
 * @param {string} img 反馈图片
 */
export function postFeedback(id: number, content: string, img: string) {
  return http.post('/newxyrj/public/user/feedback/add', {
    content,
    feedback_category_id: id,
    img_url: img,
  })
}

/**
 * 获取历史反馈
 * @param { object } param0 分页
 * @param { number } param0.pageindex 页码
 * @param { number } param0.pagesize 单页数量
 */
export function getFeedbackList({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.get('/newxyrj/public/user/feedback/list', {
    pageindex,
    pagesize,
  })
}
